import api from '../api';

// Helper function để tạo headers với token
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// Designer Design Case API functions
export const designerDesignCaseApi = {
  // Lấy tất cả available cases (chưa được assign)
  getAvailableCases: async (token) => {
    try {
      const response = await api.get('/design-cases/available', {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getSellerCases: async (token, params = {}) => {
    
  },

 
  getMyCases: async (token, params = {}) => {
    try {
      const response = await api.get('/design-cases/assigned', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },


  // Assign case cho designer
  assignCase: async (token, caseId) => {
    try {
      const response = await api.put(`design-cases/${caseId}/assign`,{}, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error assigning case:', error);
      throw error;
    }
  },

  // Unassign case (trả lại case)
  unassignCase: async (token, caseId) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}/unassign`, {}, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error unassigning case:', error);
      throw error;
    }
  },

  // Cập nhật design case
  updateDesignCase: async (token, caseId, caseData) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}`, caseData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error updating design case:', error);
      throw error;
    }
  },
   // Upload design URLs
   uploadUrlDesignFile: async (token, caseId, fileData) => {
    try {
   
      const response = await api.put(`/design-cases/${caseId}/upload-urls`, {design_urls: fileData}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response;
    } catch (error) {
      console.error('Error uploading design URLs:', error);
      throw error;
    }
  },

  // Upload design file
  uploadDesignFile: async (token, caseId, fileData) => {
    try {
      const formData = new FormData();
      formData.append('file', fileData);
      
      const response = await api.post(`/designer/cases/${caseId}/upload`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Error uploading design file:', error);
      throw error;
    }
  },

  // Upload multiple design files
  uploadMultipleDesignFiles: async (token, caseId, files) => {
    try {
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append('files', file);
      });
      
      const response = await api.post(`/designer/cases/${caseId}/upload-multiple`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Error uploading multiple design files:', error);
      throw error;
    }
  },

  // Delete design file
  deleteDesignFile: async (token, caseId, fileId) => {
    try {
      const response = await api.delete(`/designer/cases/${caseId}/files/${fileId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error deleting design file:', error);
      throw error;
    }
  },

  // Mark case as completed
  completeCase: async (token, caseId, completionData = {}) => {
    try {
      const response = await api.put(`/designer/cases/${caseId}/complete`, completionData, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error completing case:', error);
      throw error;
    }
  },

 
};

export default designerDesignCaseApi; 